<div [ngClass]="{
        'ai-file-preview-box': true,
        'ai-file-preview-box-error': fileItemPreview()?.error,
        'ai-file-preview-box-mimetype-pdf': fileItemPreview()?.mimeType === 'application/pdf',
        'ai-file-preview-box-mimetype-docx': fileItemPreview()?.mimeType === 'application/docx',
        'ai-file-preview-box-mimetype-xlsx': fileItemPreview()?.mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'ai-file-preview-box-mimetype-md': fileItemPreview()?.mimeType === 'text/markdown',
        'ai-file-preview-box-mimetype-html': fileItemPreview()?.mimeType === 'text/html',
        'ai-file-preview-box-mimetype-txt': fileItemPreview()?.mimeType === 'text/plain',
        'ai-file-preview-box-mimetype-csv': fileItemPreview()?.mimeType === 'text/csv',
        'ai-file-preview-box-mimetype-json': fileItemPreview()?.mimeType === 'application/json',
        'ai-file-preview-box-loading': fileItemPreview()?.loading,
        'ai-file-preview-box-disabled': disabled(),
        'ai-file-preview-box-processing': fileItemPreview()?.processing,
       }">

    <div class="ai-file-preview-info">
        @if (fileItemPreview()?.loading) {
            <div class="ai-file-preview-info-first-item">{{ fileItemPreview()?.name }}</div>
            <div
                class="ai-file-preview-info-second-item">{{ fileItemPreview()?.size?.toString() | bytesConverter: 2 }}
            </div>
        } @else {
            <div class="ai-file-preview-info-first-item">{{ fileItemPreview()?.name }}</div>
            <div
                class="ai-file-preview-info-second-item">{{ fileItemPreview()?.size?.toString() | bytesConverter: 2 }}
            </div>
        }
    </div>
    <div class="ai-file-preview-actions">
        @if (fileItemPreview()?.error && !disabled()) {
            <div style="margin-left: 1px;">
                <ai-button
                    [transparent]="true"
                    [border]="'hidden'"
                    [size]="'medium'"
                    [disabled]="fileItemPreview()?.loading ?? false"
                    (click)="onRetryButtonClicked($event)">

                    <ai-icon [fontIcon]="'fa-solid fa-arrow-rotate-right'"></ai-icon>
                </ai-button>
            </div>
        }

        @if (!fileItemPreview()?.loading && deletable() && !fileItemPreview()?.processing && !disabled()) {
            <div style="margin-right: 2px;">
                <ai-button
                    [transparent]="true"
                    [border]="'hidden'"
                    [size]="'medium'"
                    [shape]="'round'"
                    [disabled]="fileItemPreview()?.loading ?? false"
                    (click)="onDeleteButtonClicked($event)">

                    <ai-icon [fontIcon]="'fa-solid fa-xmark'"></ai-icon>
                </ai-button>
            </div>
        }
    </div>
</div>
